import { Logger } from '@frontend/logger';
import { SlotActuatorClient } from '@frontend/slot/api';

export interface OpenSlotParams {
    accountId: string;
    spotId: string;
    moduleId: string;
    slotId: string;
    iotId?: string;
}

export const openSlot = async (params: OpenSlotParams): Promise<boolean> => {
    const { accountId, spotId, moduleId, slotId, iotId } = params;

    try {
        await SlotActuatorClient.openSlot(accountId, spotId, moduleId, slotId, {
            iot_id: iotId
        });
        return true;
    } catch (error) {
        Logger.error('Failed to open slot', error);
        return false;
    }
};

export const openMultipleSlots = async (slots: OpenSlotParams[]): Promise<boolean> => {
    try {
        for (const slot of slots) {
            await openSlot(slot);
        }
        return true;
    } catch (error) {
        Logger.error('Failed to open slots', error);
        return false;
    }
};
